import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { buttonSizeToHeight } from '../Button';
import { Mute } from '../Icons/Icon/Mute';
import { Volume } from '../Icons/Icon/Volume';
import { Button, PauseIcon, StyledMuteButton } from './styles';
const StyledButton = styled(Button) `
  background-color: ${o => o.theme.color.fill.background};
  &:hover {
    background-color: ${o => o.theme.color.fill.subtle};
  }
  height: ${o => buttonSizeToHeight(o.size ?? 'medium')};
`;
export const PauseButton = ({ paused, size = 'medium', ...rest }) => {
    return (_jsx(StyledButton, { type: 'button', borderless: true, size: size, ...rest, children: paused ? _jsx(PlayIcon, {}) : _jsx(PauseIcon, {}) }));
};
export const MuteButton = ({ onClick, isMuted, mutedText, notMutedText }) => {
    return (_jsx(StyledMuteButton, { "aria-label": !isMuted ? mutedText : notMutedText, type: 'button', onClick: onClick, size: 'medium', borderless: true, children: isMuted ? _jsx(Mute, {}) : _jsx(Volume, {}) }));
};
export const PlayIcon = styled.div `
  background: transparent;
  height: 34px;
  min-width: 34px;
  position: absolute;

  &::after {
    content: '';
    display: block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 8px solid
      ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
    height: 0;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-36%, -50%);
    width: 0;
  }
`;
//# sourceMappingURL=index.js.map